/* eslint-disable no-console */
import React from 'react';
import './style.scss';
import Slider from 'react-slick';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import getCloudinary from '../../utils/getCloudinary';


const CategoryItem = ({
    title, subtitle, mainText, image, to, ...props
}) => {
    const content = (
        <div className="product-category-selector__item-content">
            <img
                height={170}
                src={image}
                alt={title}
            />
            <div className="product-category-selector__item-content__title is-size-5-touch is-size-4-desktop has-text-centered has-text-white">{title}</div>
            <div className="product-category-selector__item-content__subtitle has-text-centered has-text-white">{subtitle}</div>
            <div className="product-category-selector__item-content__main-text has-text-centered has-text-white">{mainText}</div>
            <Link to={to} className="button is-large track-order-button mt-1 product-category-selector__item-content__action is-white">Buy Now</Link>
        </div>
    );

    return (
        <div
            className="product-category-selector__item"
            {...props}
        >
            {content}
        </div>
    );
};

CategoryItem.defaultProps = {
};
CategoryItem.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    mainText: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    image: PropTypes.node.isRequired,
};

const settings = {
    className: 'center',
    centerMode: true,
    infinite: true,
    centerPadding: '60px',
    slidesToShow: 3,
    speed: 250,
    focusOnSelect: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ],
};
const ProductCategorySelector = () => {
    const [slickRef, setSlickRef] = React.useState(null);
    const [componentMounted, setComponentMounted] = React.useState(null);
    React.useEffect(() => {
        if (slickRef) {
            setTimeout(() => {
                if (slickRef) {
                    slickRef.slickGoTo(6);
                }
            }, 1000);
        }
    }, [slickRef]);

    React.useEffect(() => {
        setComponentMounted(true);
    }, []);
    return (
        <div id="product-category-selector" className="product-category-selector is-theme-info">
            <div className="product-category-selector__backdrop" />

            {
                componentMounted && (
                    <Slider
                        {...settings}
                        ref={ref => setSlickRef(ref)}
                    >
                        <CategoryItem
                            title="CBD E-Liquids"
                            subtitle="600mg / 300mg / 100mg - Berry Kush / Lemon Haze / Menthol / Strawberry Diesel / Watermelon Kush / Vanilla / Unflavoured"
                            mainText="Terpenes work synergistically with cannabinoids. Researchers are now discovering that terpenes have a direct link to the efficacy of cannabinoids."
                            image={getCloudinary()
                                .url(
                                    'dashboard-uploads/e-liquids-lined-up_vgrfby',
                                    {
                                        height: 800,
                                        crop: 'fit',
                                        fetch_format: 'auto',
                                    },
                                )}
                            to="e-liquids"
                        />
                        <CategoryItem
                            title="CBD Delivery System"
                            subtitle="Black / Grey / White"
                            image={getCloudinary()
                                .url(
                                    'dashboard-uploads/all-ace-devices-image_lr5ge4',
                                    {
                                        height: 800,
                                        crop: 'fit',
                                        fetch_format: 'auto',
                                    },
                                )}
                            to="/cbd-delivery-system-feature"
                        />
                        <CategoryItem
                            title="CBD Pods"
                            subtitle="2 x ~2ml - Berry Kush / Brazilian Mango / Ice Peach / Wild Mint / Amalfi Lemon"
                            image={getCloudinary()
                                .url(
                                    'dashboard-uploads/pods-product-category-image_szjdab',
                                    {
                                        height: 800,
                                        crop: 'fit',
                                        fetch_format: 'auto',
                                    },
                                )}
                            to="/pods"
                        />
                        <CategoryItem
                            title="CBD Skincare"
                            subtitle="Body Lotion / Face Cream - 150ml / 50ml"
                            mainText="Swiss mountain water, Swiss Alps edelweiss, Swiss CBD extract and jojoba oil. Allergen-free formula, no animal testing, GMP-certified and 100% vegan."
                            image={getCloudinary()
                                .url(
                                    'dashboard-uploads/skincare-all-products_kco94f',
                                    {
                                        height: 800,
                                        crop: 'fit',
                                        fetch_format: 'auto',
                                    },
                                )}
                            to="/skincare"
                        />
                        <CategoryItem
                            title="CBD Supplements"
                            subtitle="CBD Broad Spectrum Oil / CBD Capsules"
                            mainText="GMP-certified CBD in easy to use supplements. Made using only the highest quality ingredients for your peace of mind. Empower your body with the benefits of CBD."
                            image={getCloudinary()
                                .url(
                                    'dashboard-uploads/supplements-all-products_gfz3hg',
                                    {
                                        height: 800,
                                        crop: 'fit',
                                        fetch_format: 'auto',
                                    },
                                )}
                            to="/supplements"
                        />

                    </Slider>
                )
            }
        </div>
    );
};

ProductCategorySelector.defaultProps = {

};
ProductCategorySelector.propTypes = {

};

export default ProductCategorySelector;
